const gettersInvestment = {
	Downpayment(state) {
		if (
			state.result['home_price']
			&& state.result['home_price'] !== ''
			&& state.result['downpayment']
			&& state.result['downpayment'] !== ''
		) {
			return (+state.result['home_price'] * +state.result['downpayment']) / 100;
		}
		return 0;
	},
	LoanAmount(state, getters) {
		if (
			state.result['home_price']
			&& state.result['home_price'] !== ''
			// && state.Downpayment
			// && state.Downpayment !== 0
		) {
			return +state.result['home_price'] - +getters.Downpayment;
		}
		return 0;
	}
};

export { gettersInvestment };
